var map = {
	"./skins/aktionaerliga-2024": [
		129,
		11
	],
	"./skins/aktionaerliga-2024.css": [
		383,
		25
	],
	"./skins/aktionaerliga-2024.js": [
		129,
		11
	],
	"./skins/bibliotekarernes-sep-2024": [
		130,
		10
	],
	"./skins/bibliotekarernes-sep-2024.css": [
		384,
		24
	],
	"./skins/bibliotekarernes-sep-2024.js": [
		130,
		10
	],
	"./skins/boersen-spiel-sep-2024": [
		131,
		9
	],
	"./skins/boersen-spiel-sep-2024.css": [
		385,
		23
	],
	"./skins/boersen-spiel-sep-2024.js": [
		131,
		9
	],
	"./skins/borsgruppenliu-jan-2024": [
		132,
		8
	],
	"./skins/borsgruppenliu-jan-2024.css": [
		386,
		22
	],
	"./skins/borsgruppenliu-jan-2024.js": [
		132,
		8
	],
	"./skins/fynske-bank-sep-2024": [
		133,
		7
	],
	"./skins/fynske-bank-sep-2024.css": [
		387,
		21
	],
	"./skins/fynske-bank-sep-2024.js": [
		133,
		7
	],
	"./skins/ibc-jan-2024": [
		134,
		12
	],
	"./skins/ibc-jan-2024.js": [
		134,
		12
	],
	"./skins/sdu-businessschooldays-2024": [
		135,
		6
	],
	"./skins/sdu-businessschooldays-2024.css": [
		388,
		20
	],
	"./skins/sdu-businessschooldays-2024.js": [
		135,
		6
	],
	"./skins/skoledyst-oct-2023": [
		136,
		5
	],
	"./skins/skoledyst-oct-2023.css": [
		389,
		19
	],
	"./skins/skoledyst-oct-2023.js": [
		136,
		5
	],
	"./skins/skolernes-aktiedyst-2024": [
		137,
		4
	],
	"./skins/skolernes-aktiedyst-2024.css": [
		390,
		18
	],
	"./skins/skolernes-aktiedyst-2024.js": [
		137,
		4
	],
	"./skins/sommerdysten-ad-2023": [
		138,
		3
	],
	"./skins/sommerdysten-ad-2023.css": [
		391,
		17
	],
	"./skins/sommerdysten-ad-2023.js": [
		138,
		3
	],
	"./skins/sommerdysten-ak-2023": [
		139,
		2
	],
	"./skins/sommerdysten-ak-2023.css": [
		392,
		16
	],
	"./skins/sommerdysten-ak-2023.js": [
		139,
		2
	],
	"./skins/sommerdysten-is-2023": [
		140,
		1
	],
	"./skins/sommerdysten-is-2023.css": [
		393,
		15
	],
	"./skins/sommerdysten-is-2023.js": [
		140,
		1
	],
	"./skins/sydbank-sep-2020": [
		141,
		0
	],
	"./skins/sydbank-sep-2020.css": [
		394,
		14
	],
	"./skins/sydbank-sep-2020.js": [
		141,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 287;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/dynamic lazy ^\.\/.*$
// module id = 287
// module chunks = 26